import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { Link, useNavigate } from 'react-router-dom';
import { wsFindBy } from 'services/WService';
import { Add, Visibility } from '@material-ui/icons';
import Badge from 'components/Badge/Badge';
import { Box } from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Procesado', accessor: 'processed', width: 120 },
  { Header: 'Producto a convertir', accessor: 'ItemName', width: 230 },
  { Header: 'Cantidad', accessor: 'Quantity', width: 110 },
  { Header: 'Producto convertido', accessor: 'ItemName2', width: 230 },
  { Header: 'Cantidad', accessor: 'Quantity2', width: 110 },

  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Fecha creación', accessor: 'created_at', width: 200 },
  { Header: 'Fecha actualización', accessor: 'updated_at', width: 200 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function MaterialListIndex() {
  const [materialLists, setMaterialLists] = useState([]);
  const [filters, setFilters] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const navigate = useNavigate();

  async function listMaterialLists() {
    setDataLoading(true);
    let data = { ...filters };
    let res = await wsFindBy('logi/material-list', data);
    setDataLoading(false);
    if (res.success) {
      setMaterialLists(res.data);
    }
  }

  useEffect(() => {
    listMaterialLists();
  }, []);

  return (
    <CardContainer
      // title="Lista de materiales"
      title={(<>Lista de materiales {dataLoading && <LoadingSpinner />}</>)}
      onClick={() => navigate('0')}
      iconColor="success"
      icon={<Add />}
    >
      {/* Filtros */}
      <FilterCustom
        zone
        provider
        dateRange
        warehouse="N"
        getFilter={setFilters}
        // Estado
        state
        nameState="state_migrate"
        optionValues={['D', 'V', 'X', 'P']}
        nameOptions={['Borrador', 'Validado', 'Procesando', 'Completo']}
      />
      <ReactTable
        excelName="lista-materiales"
        defaultWidth={1000}
        formatDate="DD-MM-YYYY HH:mm"
        columns={columns}
        data={materialLists.map((materialList, index) => {
          return {
            num: (
              <Box display="flex" alignItems="center">
                {index + 1}
                <AllowedGuard permission={ConstantPermissions.LOGI_MATERIAL_LISTS_SHOW}>
                  <RegularButton justIcon round simple>
                    <Link to={`${materialList.id}`}>
                      <Visibility />
                    </Link>
                  </RegularButton>
                </AllowedGuard>
              </Box>
            ),
            processed:
              materialList.sapAnnuled !== null ? (
                <Badge color={materialList.sapAnnuled === 'P' ? 'warning' : 'danger'}>
                  {materialList.sapAnnuled === 'P' ? 'Procesando anulación' : 'Anulado'}
                </Badge>
              ) : (
                <Badge color={materialList.Code === null ? 'warning' : 'success'}>
                  {materialList.Code === null ? 'No' : 'Si'}
                </Badge>
              ),
            ItemName: materialList.from_product.ItemName,
            Quantity: materialList.from_quantity,
            ItemName2: materialList.to_product.ItemName,
            Quantity2: materialList.to_quantity,
            created_user_name: materialList.created_user?.name ?? '-',
            created_at: materialList.created_at,
            updated_at: materialList.updated_at,
          };
        })}
      />
    </CardContainer>
  );
}

export default MaterialListIndex;
